import IndustryHighlights from './IndustryHighlights'

export default IndustryHighlights
